import {useState} from 'react'
import {Button} from '../button/button.jsx'
import styles from './connection-error.module.scss'

/**
 * Shown by the route guards when the session can't be validated because the server
 * is unreachable (network error / timeout / 5xx). The token is kept, so retrying
 * restores the session once the backend is back.
 * @param {{onRetry: () => Promise<void>|void}} props
 */
export function ConnectionError({onRetry}) {
    const [retrying, setRetrying] = useState(false)

    async function retry() {
        setRetrying(true)
        try {
            await onRetry()
        } finally {
            setRetrying(false)
        }
    }

    return (
        <div className={styles.center}>
            <div className={styles.brand}>
                <span className={styles.glyph} aria-hidden="true"/>
                <span className={styles.name}>VerdaSync</span>
            </div>
            <h1 className={styles.title}>Can't reach the server</h1>
            <p className={styles.body}>
                We couldn't connect to VerdaSync. Your session is still active — check your
                connection and try again.
            </p>
            <Button onClick={retry} loading={retrying}>Retry</Button>
        </div>
    )
}
